// extracted by mini-css-extract-plugin
export default {"setting-container":"keyBoardSelect_setting-container__fpAQr","setting":"keyBoardSelect_setting__+ftIe"};